import CoreuiController from "../lib/coreui-controller"
import PasswordInput from "../coreui/password-input"

export default class CoreuiPasswordInputController extends CoreuiController {
  static Component = PasswordInput
}
